"use strict";
import React from "react";
import _ from "underscore";
function noAuditFlagsMessage() {
  return /* @__PURE__ */ React.createElement("div", { className: "alert-box--highlight" }, "No Audit Flags Set");
}
function showAuditFlag(auditFlag) {
  if (auditFlag.customMessage) {
    return /* @__PURE__ */ React.createElement("li", null, auditFlag.label, ": ", auditFlag.customMessage);
  } else {
    return /* @__PURE__ */ React.createElement("li", null, auditFlag.label);
  }
}
export default React.createClass({
  render: function() {
    return /* @__PURE__ */ React.createElement("div", null, this.hasAuditFlags() ? this.showAuditFlags() : noAuditFlagsMessage());
  },
  hasAuditFlags: function() {
    return !_.isEmpty(this.props.flags);
  },
  showAuditFlags: function() {
    return /* @__PURE__ */ React.createElement("ul", { className: "factor-invoice--audit-flags" }, _.map(this.props.flags, showAuditFlag));
  }
});
